// extracted by mini-css-extract-plugin
export default {"box":"model-cell_box__OE8sn"};